import {
  CButton,
  CButtonGroup,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";

interface TreasuryConfirmModalProps {
  show: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  // Color de CoreUI: tambien define la clase modal-<color> del encabezado.
  color?: string;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
}

const TreasuryConfirmModal: React.FC<TreasuryConfirmModalProps> = ({
  show,
  title,
  message,
  confirmLabel,
  color = "danger",
  onCancel,
  onConfirm,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const onConfirmClick = async () => {
    setSubmitting(true);
    await onConfirm();
    setSubmitting(false);
  };

  return (
    <CModal show={show} className={`modal-${color}`} onClose={onCancel}>
      <CModalHeader closeButton>
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <h5>{message}</h5>
      </CModalBody>
      <CModalFooter>
        <CButtonGroup>
          <CButton color="secondary" onClick={onCancel} disabled={submitting}>
            Cancelar
          </CButton>
          <CButton color={color} onClick={onConfirmClick} disabled={submitting}>
            {submitting ? (
              <Spinner
                animation="grow"
                style={{ height: "17px", width: "17px", marginRight: "10px" }}
              />
            ) : (
              <></>
            )}
            {confirmLabel}
          </CButton>
        </CButtonGroup>
      </CModalFooter>
    </CModal>
  );
};

export default TreasuryConfirmModal;
